import React, { Component, useState } from "react";
import { useSelector } from "react-redux";
import CardDisplay from "../../components/CardDisplay";
import { NotificationsOff } from "@mui/icons-material";
import { Typography } from "@mui/material";
const Notifications = () => {
  const [origin, setOrigin] = useState("purchased");
  const [redirectUrl, setRedirectUrl] = useState("/user-profile");
  const [toggleAction, setToggleAction] = useState(false);
  const [actionLable, setActionLable] = useState("Read Book");

  const user = useSelector((state) => {
    return state.logger;
  });
  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 10,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 20,
            paddingTop: 50,
          }}
        >
          {" "}
          <NotificationsOff style={{ fontSize: 60, color: "#444" }} />
          <Typography variant="subtitle2">No Notifications</Typography>
        </div>
      </div>
    </>
  );
};

export default Notifications;
